import React, { useState } from "react";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const res = await axios.post(`${API}/subscribe`, { email, source: "footer" });
      if (res.data.status === "already_subscribed") {
        toast("You're already on the list \u2014 thank you!");
      } else {
        toast.success("You're in! Watch your inbox for exclusive offers.");
      }
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex items-center gap-2 max-w-sm">
      <input
        type="email"
        required
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 bg-transparent border border-[#F4EFE8]/25 rounded-sm px-4 py-3 text-[14px] text-[#F4EFE8] placeholder-[#F4EFE8]/40 outline-none focus:border-[#F4EFE8] transition-colors"
      />
      <button
        type="submit"
        disabled={sending}
        aria-label="Subscribe"
        className="btn-lux-light h-[46px] w-[46px] rounded-sm flex-shrink-0 disabled:opacity-60"
      >
        <ArrowRight size={16} />
      </button>
    </form>
  );
};

export default NewsletterForm;
